<template>
  <section class="animation-button">
    <slot />
    <div class="particle-wrapper" :class="{'-start': animationStart}">
      <img
        src="@images/animation-button/ico_particle.png"
        v-for="item in particle"
        :key="item"
        class="particle"
      />
    </div>
  </section>
</template>
<script>
export default {
  name: 'animationButton.vue',
  computed: {
    particle(){
      const particles = new Array(20)
      return particles
    }
  },
  data() {
    return {
      animationStart: false
    }
  },
  mounted(){
    window.setTimeout(this.startAnimation, 2250)
  },
  methods: {
    startAnimation(){
      this.animationStart = true
    }
  },
}
</script>
<style lang="scss" scoped>
@keyframes blink {
  75% {
    opacity: 1;
  }
}
.animation-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 350px;
  background-image: url(#{$img-path}animation-button/bg_vote-area.png), url(#{$img-path}animation-button/bg_vote-mask.png);
  background-repeat: no-repeat, no-repeat;
  background-size: 100% auto, 100% auto;
  background-position: 50% 0, 50% 10px;
  &::before {
    content: "";
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform : translate(-50%,-50%);
    display: block;
    width: 640px;
    height: 417px;
    opacity: 0;
    background-image: url(#{$img-path}animation-button/btn_vote-blink.png);
    background-repeat: no-repeat;
    background-size: auto 100%;
    animation: blink 2.8s ease-in-out infinite;
  }
  .particle-wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    visibility: hidden;
    &.-start {
      visibility: visible;
    }
  }
  .particle {
    position: absolute;
    top: -100px;
    left: 0;
    z-index: 3;
  }
}
@for $i from 1 through 20 {
  @keyframes particle-animation-#{$i} {
    10% {
      opacity: 1;
    }
    30% {
      transform: translate((random(710) - 54px), (random(450) + 38px));
      opacity: 0;
    }
  }
  .particle:nth-child(#{$i}){
    animation: particle-animation-#{$i} random(5000) + 2500ms infinite;
    animation-delay: random() * 100ms;
    transform: translate(306px, 248px);
    opacity: 0;
  }
}

</style>